export default class Price {
    constructor(currency) {
        this.currency = currency;
        this.net = {
            numerator: null,
            denominator: null,
        };
        this.gross = {
            numerator: null,
            denominator: null,
        };
        this.vat = {
            numerator: null,
            denominator: null,
        };
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const price = new Price();
        price.currency = data.currency;
        price.net = {
            numerator: data.net.data.numerator,
            denominator: data.net.data.denominator,
        };
        price.gross = {
            numerator: data.gross.data.numerator,
            denominator: data.gross.data.denominator,
        };
        price.vat = {
            numerator: data.vat.data.numerator,
            denominator: data.vat.data.denominator,
        };

        Object.seal(price);
        return price;
    }
}
